"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireDefault(require("react"));
var _loginConnector = _interopRequireDefault(require("../../login/login-connector"));
var _link = _interopRequireDefault(require("../core/link"));
var _button = _interopRequireDefault(require("../core/button"));
var _competitionNavbarItems = _interopRequireDefault(require("./competition-navbar-items"));
var _navBarMain = _interopRequireDefault(require("../core/nav-bar-main"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../schema/security/user-is-system-admin"));
var _userCanViewStats = _interopRequireDefault(require("../../schema/security/user-can-view-stats"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: false,
  path: "/year/:yearID/competition/:competitionSlug",
  component: _competitionNavbarItems.default
});
var _ref2 = /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/statistics"
}, "Statistics");
var _ref3 = /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/my-account"
}, "My Account");
function NavBar({
  isAuthenticated,
  user,
  failedChargesforUser,
  userEntriesAwaitingPayment,
  onLogout,
  onToggleLogin
}) {
  return /*#__PURE__*/_react.default.createElement(_navBarMain.default, null, _ref, !(isAuthenticated && (0, _userIsSystemAdmin.default)(user)) ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: "/settings",
    style: {
      marginLeft: '1rem'
    }
  }, "Settings"), !(isAuthenticated && (0, _userCanViewStats.default)(user)) ? null : _ref2, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: "/calendar-applications",
    style: {
      marginLeft: '1rem'
    }
  }, "Calendar-Applications"), /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: "/help",
    style: {
      marginLeft: '1rem'
    }
  }, "Help"), /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-xs-right"
  }, _ref3, !isAuthenticated ? null : failedChargesforUser && failedChargesforUser.length ? /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link text-warning",
    activeClassName: "active",
    to: "/submit-new-payment"
  }, "FAILED PAYMENTS (", failedChargesforUser.length, ")") : !userEntriesAwaitingPayment ? null : /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    activeClassName: "active",
    to: "/checkout"
  }, "Checkout (", userEntriesAwaitingPayment, ")"), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-item"
  }, isAuthenticated ? /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-test-id": "navbar-logout-button",
    onClick: onLogout
  }, /*#__PURE__*/_react.default.createElement("strong", null, user.email), "(Logout)") : /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-test-id": "navbar-login-button",
    onClick: onToggleLogin
  }, "Login/Register"))));
}
var _ref4 = {
  userEntriesAwaitingPayment: true,
  failedChargesforUser: {
    id: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)((0, _loginConnector.default)(NavBar), props => {
  return _ref4;
}, undefined, {
  renderLoading: true
});